import { Box } from '@mui/material';
import { Review } from '@/graphql/__generated/sdk';
import { ReviewItem } from './ReviewItem';
import { reviewsListContainer, reviewListItem } from './ReviewsList.styles';
export default function ReviewsList({
  reviews
}: {
  readonly reviews?: Review[];
}) {
  const displayReviews = reviews ?? [];
  return <Box sx={reviewsListContainer} data-sentry-element="Box" data-sentry-component="ReviewsList" data-sentry-source-file="ReviewsList.tsx">
			{displayReviews.map(review => <Box key={review.reviewId} sx={reviewListItem}>
					<ReviewItem review={review} />
				</Box>)}
		</Box>;
}